import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.css";

const CustomChip = ({active=true, children, className, closable=false, description, onClick, onClose, style}) => {

  return (
    <div>
      <div
        style={style}
        onClick={onClick}
        className={`CustomTag CustomChip${closable ? " closable" : ""}${
          !active ? " inactive" : ""
        } ${className}`}
      >
        {closable && (
          <FontAwesomeIcon
            onClick={() => {if (onClose) onClose(); }}
            className={"closeIcon"}
            icon={["fal", "times"]}
          />
        )}
        {description}
      </div>
      {children}
    </div>
  );
};

export default CustomChip;
